import { useQuery } from '@apollo/client';
import { GET_DASHBOARD_NEW_APPLICATIONS } from '@gql/alerts';

export const useGetDashboardNewApplications = (date?: Date, method?: 'direct_email' | 'premium', limit = 10) => {
    const { data, loading, error, refetch } = useQuery(GET_DASHBOARD_NEW_APPLICATIONS, {
        variables: { limit, ...(date && { date }), ...(method && { method }) },
        notifyOnNetworkStatusChange: true,
    });

    return {
        applications: data?.getDashboardNewApplications ?? [],
        loading,
        error,
        refetch,
    };
};
